// extracted by mini-css-extract-plugin
export default {"QuizList":"QuizList_QuizList__g-jFf"};